var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'list-tab': true, 'border-hr': !_vm.hideHr }},_vm._l((_vm.tabs),function(tab){return _c('div',{key:tab.number,staticClass:"tab",class:{ 'active-tab': _vm.activeTab === tab.number },on:{"click":function($event){return _vm.changeTab(tab.number)}}},[_vm._v(" "+_vm._s(tab.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }